// extracted by mini-css-extract-plugin
export default {"tableContainer":"TableArea_tableContainer__WmJcF","tableHeader":"TableArea_tableHeader__Ae+Xn","tableContent":"TableArea_tableContent__VEMJh"};